import React from 'react';
import { Icon, IconProps } from '@clariness/icon';

export const Info: React.FC<IconProps> = ({ size = 23, ...props }) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        fill={props.color ? props.color : 'currentColour'}
      >
        <g fill="none">
          <path d="M0 0h24v24H0V0z" />
          <path
            d="M0 0h24v24H0V0z"
            opacity=".87"
          />
        </g>
        <path d="M11 7h2v2h-2zm1 10c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1zm0-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
      </svg>
    </Icon>
  );
};
